import { AxiosResponse } from 'axios';

import { IDeleteResponse } from 'models/http/common';
import { IDeleteFeedbacksFilters, IGetFeedbacksFilters, IGetFeedbacksTableResponse } from 'models/http/feedbacks';
import {
  ICreateFeedbackRequest,
  ICreateFeedbackResponse,
  IGetFeedbacksResponse,
} from 'pages/Trips/TripsTripInfo/TripsTripFeedback/TripsTripFeedback.model';
import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';
import { ModelsNames } from 'utils/enums/model-names';
import { prepareFiltersOfSelection, prepareQPFromFilters, serverAxios } from 'utils/http';

class FeedbacksHttp {
  public static DataExportRoute = `${ModelsNames.Feedbacks}/data-export`;
  private static route = `/${ModelsNames.Feedbacks}`;

  public async get(filters?: IGetFeedbacksFilters, abortController?: AbortController): Promise<IGetFeedbacksTableResponse> {
    const query = prepareQPFromFilters(filters || {});

    return serverAxios
      .get(`${FeedbacksHttp.route}?${query.toString()}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetFeedbacksTableResponse>) => response.data);
  }

  public async getFeedbacksByTripId(id: number, abortController?: AbortController): Promise<IGetFeedbacksResponse> {
    return serverAxios
      .get(`${FeedbacksHttp.route}/by-trip/${id}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetFeedbacksResponse>) => {
        return response.data;
      });
  }

  public async create(data: ICreateFeedbackRequest): Promise<ICreateFeedbackResponse> {
    return serverAxios
      .post(`${FeedbacksHttp.route}`, data, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<ICreateFeedbackResponse>) => {
        return response.data;
      });
  }

  public async delete(ids: number[]): Promise<IDeleteResponse>;
  public async delete(filters: IDeleteFeedbacksFilters): Promise<IDeleteResponse>;
  public async delete(filters: number[] | IDeleteFeedbacksFilters): Promise<IDeleteResponse> {
    return serverAxios
      .delete(FeedbacksHttp.route, {
        data: prepareFiltersOfSelection(filters),
      })
      .then((response: AxiosResponse<IDeleteResponse>) => response.data);
  }
}

export default FeedbacksHttp;
